module.exports = __webpack_public_path__ + "media/flags/gb-nir-2ee63872.svg";